export { default as UserListTemplate } from './UserListTemplate';
export { default as UserEditTemplate } from './UserEditTemplate';
export { default as UserPasswordChangeTemplate } from './UserPasswordChangeTemplate';
export { default as UserCreateTemplate } from './UserCreateTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/index.js